import { makeAdSupportedGamePolicy } from './game-ads'

/** Keywright — 문 여는 순서가 퍼즐인 탑. 무료 + AdMob 광고 + 광고 제거 인앱결제. */
export const KEYWRIGHT_POLICY = makeAdSupportedGamePolicy({
  slug: 'keywright',
  title: 'Keywright Privacy Policy',
  name: 'Keywright',
  storedOnDevice:
    'Which floors you have cleared, the fewest moves you took on each, how many floors you have finished in total, whether you bought the ad removal, and your sound and music volume are the only things the app keeps.',
  removeAdsProductId: 'com.cottonray.keywright.remove_ads',
  effectiveDate: 'August 25, 2026',
  history: [
    'August 25, 2026 — established (structured on Article 30 of the Personal Information Protection Act, including notice of transfers abroad), covering advertising through Google AdMob (a banner in a reserved strip along the bottom while you play and one interstitial when a game ends) and the one-off in-app purchase that removes them. The game requests network access for those two things only',
  ],
})
